import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AppSettings } from "../../../app.settings";
import { Settings } from "../../../app.settings.model";

import { AuthService } from "../../services/auth-services.service";
@Component({
  selector: "app-not-found",
  templateUrl: "./not-found.component.html",
})
export class NotFoundComponent {
  public settings: Settings;
  constructor(
    public appSettings: AppSettings,
    public router: Router,
    private auth: AuthService
  ) {
    this.settings = this.appSettings.settings;
  }

  searchResult(): void {
    this.router.navigate(["/search"]);
  }
  goHome(): void {
    if (this.auth.hasSession) {
      this.router.navigate(["/main"]);
    } else {
      this.router.navigate(["/"]);
    }
  }

  ngAfterViewInit() {
    this.settings.loadingSpinner = false;
  }
}
